// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getIOLLenses } from "../../../api";
import { IOLLensType } from "../../../types";

export const useIOLLenses = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<IOLLensType>>({
    queryKey: ["iol-lenses", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();

      const token = await getToken();
      return getIOLLenses(token, clinicId);
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
